import React, { useState, useEffect } from 'react';
import { toggleVapiCall, subscribeVapiCall } from '../utils/vapiVoice';
import './FloatingSupport.css';

const FloatingSupport = () => {
  const [isCalling, setIsCalling] = useState(false);
  const [chatState, setChatState] = useState('closed'); // 'closed' | 'open' | 'minimized'
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth <= 768 : false
  );

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    const unsubscribe = subscribeVapiCall(setIsCalling);

    const handleChatStateChange = (e) => {
      if (e.detail && e.detail.state) {
        setChatState(e.detail.state);
      }
    };
    window.addEventListener('sgtb_ai_chat_state_change', handleChatStateChange);

    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('sgtb_ai_chat_state_change', handleChatStateChange);
      unsubscribe();
    };
  }, []);

  const handleChatClick = () => {
    if (typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent('open_sgtb_ai_chat'));
    }
  };

  // On mobile, if chat is OPEN, hide all external floating CTAs to avoid overlapping full sheet
  if (isMobile && chatState === 'open') {
    return null;
  }

  // Show Chat with AI launcher ONLY when chat is closed
  const showChatLauncher = chatState === 'closed';

  return (
    <div className={`floating-container ${isMobile ? 'mobile-view' : 'desktop-view'} chat-state-${chatState}`}>
      {/* 1. TALK TO AI MANAGER (VOICE CALL) */}
      <button
        type="button"
        onClick={toggleVapiCall}
        className={`support-btn ai-voice-btn ${isCalling ? 'active' : ''}`}
        aria-label="Talk to AI Manager"
        title="Talk to AI Manager (Voice Assistant)"
      >
        <span className="icon">{isCalling ? '🛑' : '🎙'}</span>
        <span className="btn-text">
          {isCalling ? 'End Call' : (isMobile ? 'Talk to AI' : 'Talk to AI Manager')}
        </span>
      </button>

      {/* 2. CHAT WITH AI (TEXT CHAT LAUNCHER - HIDDEN WHEN OPEN OR MINIMIZED) */}
      {showChatLauncher && (
        <button
          type="button"
          onClick={handleChatClick}
          className="support-btn ai-chat-btn"
          aria-label="Chat with AI"
          title="Chat with AI Sales Assistant"
        >
          <span className="icon">💬</span>
          <span className="btn-text">
            {isMobile ? 'Chat with AI' : 'Chat with AI'}
          </span>
        </button>
      )}

      {/* 3. WHATSAPP SUPPORT */}
      <a
        href="https://wa.me/918287691638"
        className="support-btn wa-btn"
        target="_blank"
        rel="noreferrer"
        aria-label="WhatsApp Support"
        title="Chat on WhatsApp"
      >
        <span className="icon">💬</span>
        <span className="btn-text">
          {isMobile ? 'WhatsApp' : 'WhatsApp Support'}
        </span>
      </a>
    </div>
  );
};

export default FloatingSupport;
